import { Button } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { StateTemplate } from "./StateTemplate";

export type EmptyStateProps = {
  onExit: () => void;
};

export const EmptyState = ({ onExit }: EmptyStateProps) => {
  return (
    <StateTemplate
      title="Nothing to process"
      subTitle="This request doesn't have anything left to process in the wizard."
      icon={<Icon type="info-circle" color={Colors.Neutral500} size="xx-large" />}
    >
      <Button variant="neutral" onClick={onExit} data-testid="ddq-wizard-empty-state-exit">
        Back to queue
      </Button>
    </StateTemplate>
  );
};
